export interface ValidateJobTerminalsAndLocationRequest  {
    jobId: string;
    locationAddressess: string[];
  }
  